import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { GbBaseApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-base-api.service'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { Observable } from 'rxjs'
import { EventTicketPurchaseEntity, EventTicketPurchasePayload } from './event-ticket-purchases.models'

@Injectable({
  providedIn: 'root',
})
export class EventTicketPurchasesApiService extends GbBaseApiService {
  constructor(protected http: HttpClient, @Inject(APP_CONFIG) protected appConfig: any) {
    super(http, appConfig)
  }

  createEventTicketPurchase(
    urlName: string,
    payload: EventTicketPurchasePayload,
  ): Observable<EventTicketPurchaseEntity> {
    return this.post<EventTicketPurchaseEntity>(`auctions/${urlName}/event-ticket-purchases/`, payload)
  }

  syncEventTicketPurchase(urlName: string, purchaseUuid = ''): Observable<EventTicketPurchaseEntity> {
    return this.get<EventTicketPurchaseEntity>(`auctions/${urlName}/event-ticket-purchases/${purchaseUuid}/`)
  }
}
